/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Away_Aware_Slug_BloomInputs */

const fr_away_aware_slug_bloom = /** @type {(inputs: Away_Aware_Slug_BloomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarder`)
};

/**

* @param {Away_Aware_Slug_BloomInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const away_aware_slug_bloom = /** @type {((inputs?: Away_Aware_Slug_BloomInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Away_Aware_Slug_BloomInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_away_aware_slug_bloom(inputs)
});